import { connect } from 'react-redux';
import { currentChain, currentStoreName } from 'core/selectors';
import SupportModal from '../../../components/support/SupportModal';

const mapStateToProps = state => ({
  currentChain: currentChain(state),
  currentStoreName: currentStoreName(state),
});

export default connect(mapStateToProps)(SupportModal);
